import { lazy } from "react";

export default {
  name: "Solution",
  path: "/solution",
  component: lazy(() => import("./index"))
}